var _rect, _path, _path2, _rect2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcNavBarNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5,
    fill: "#00A3FF",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.90454V16.5712C6 16.9753 6.16054 17.3629 6.44631 17.6487C6.73208 17.9345 7.11967 18.095 7.52381 18.095H18.1905C18.5946 18.095 18.9822 17.9345 19.268 17.6487C19.5537 17.3629 19.7143 16.9753 19.7143 16.5712V8.95216H16.6667",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.90454H16.6667V16.5712C16.6667 16.9753 16.8272 17.3629 17.113 17.6487C17.3987 17.9345 17.7863 18.095 18.1905 18.095M13.619 8.95216H9.04762M13.619 11.9998H10.5714",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 5,
    fill: "#00AA00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5.90479V16.5715C5 16.9756 5.16054 17.3632 5.44631 17.6489C5.73208 17.9347 6.11967 18.0953 6.52381 18.0953H17.1905C17.5946 18.0953 17.9822 17.9347 18.268 17.6489C18.5537 17.3632 18.7143 16.9756 18.7143 16.5715V8.9524H15.6667",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5.90479H15.6667V16.5715C15.6667 16.9756 15.8272 17.3632 16.113 17.6489C16.3987 17.9347 16.7863 18.0953 17.1905 18.0953M12.619 8.9524H8.04762M12.619 12H9.57143",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNavBarNews);
export default __webpack_public_path__ + "static/media/ic-navBar-news.f21cae16c16e8116206163e187cf7da1.svg";
export { ForwardRef as ReactComponent };